import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { debounceTime } from 'rxjs';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetLaudoHigienizacaoPaginated } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.model';
import { ITabelaLaudoHigienizacao } from './listagem-laudos-higienizacao-model';
import { LaudoHigienizacaoService } from 'src/app/services/LaudoHigienizacaoService/laudo-higienizacao.service';
import { formatarData, formatarPlaca } from 'src/app/core/utils/utilities';
import { AppExportBase64 } from 'src/app/services/ExportBase64/exportBase64.service';
import { IGetReportBase64 } from 'src/app/services/ReportService/report.model';
import { ImpressoraService } from 'src/app/services/ImpressoraService/impressora.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

@Component({
  selector: 'app-listagem-laudos-higienizacao',
  templateUrl: './listagem-laudos-higienizacao.component.html',
  styleUrls: ['./listagem-laudos-higienizacao.component.scss']
})
export class ListagemLaudosHigienizacaoComponent {
  isLoading: boolean = false;
  form = this._inicializarFormulario();

  showModal: boolean = false;
  pdfBase64: string = '';
  pkFunc: number = 0;

  numeroPagina: number = 0;
  tableData: ITabelaLaudoHigienizacao[] | Array<any> = [];
  pesquisaParams = {
    TxPesquisar: '',
    DtInicio: '',
    DtFim: '',
    Pagina: 0,
    TamanhoPagina: 20
  };
  maxPages: number = 1;
  expandirCardsMobile: boolean = true;
  guid = generateUUID();
  id: number = Number(localStorage.getItem('id'));

  tableColumns = [
    { header: 'Código Laudo', key: 'codigo', type: 'text' },
    { header: 'Agendamento', key: 'agendamento', type: 'text' },
    { header: 'Data do Serviço', key: 'dataServico', type: 'text' },
    { header: 'Empresa', key: 'empresa', type: 'text' },
    { header: 'Placa Cavalo', key: 'placaCavalo', type: 'text' },
    { header: 'Motorista', key: 'motorista', type: 'text' },
    {
      header: 'Ações',
      key: 'actions',
      type: 'buttons',
      buttons: [
        {
          label: 'Ticket',
          img: 'assets/icon-download.svg',
          condition: (item: any) => Number(item.codigo) > 0,
          action: (item: any) => this.exportPdf(Number(item.codigo))
        },
        {
          label: 'Visualizar',
          img: 'assets/eye-icon.png',
          condition: (item: any) => Number(item.codigo) > 0,
          action: (item: any) => this.abrirLaudoHigienizacao(Number(item.codigo))
        },
        {
          label: 'Editar',
          img: 'assets/edit.svg',
          condition: (item: any) => {
            if (!item.dataCriacao) return false;
            const dataCriacao = new Date(item.dataCriacao);
            const diffHours = (new Date().getTime() - dataCriacao.getTime()) / (1000 * 60 * 60);
            return diffHours <= 48;
          },
          action: (item: any) => this.editarLaudoHigienizacao(item)
        },
        {
          label: 'Impressão Ticket',
          img: 'assets/icon-print.svg',
          condition: (item: any) => Number(item.codigo) > 0,
          action: (item: any) => this.imprimirTicket(Number(item.codigo))
        }
      ]
    }
  ];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private laudoHigienizacaoService: LaudoHigienizacaoService,
    private appExportBase64: AppExportBase64,
    private impressoraService: ImpressoraService,
    private swalAlert: SwalAlertService
  ) { }

  private _inicializarFormulario() {
    const form = this.fb.group({
      FK_EPSA: this.fb.control(''),
      TX_PLCA_CRRT: this.fb.control(''),
      DT_GATE_ENTR_INIC: this.fb.control(''),
      DT_GATE_ENTR_FIM: this.fb.control('')
    });
    return form;
  }

  editarLaudoHigienizacao(item: any) {
    const queryParams = {
      ...item,
      modoLaudoHigienizacao: 'Editar'
    };
    this.router.navigate(['cadastro/laudo-higienizacao'], {
      queryParams: queryParams
    });
  }

  ngOnInit() {
    this.getLaudoHigienizacao();

    const queryParams = this.router.parseUrl(this.router.url).queryParams;
    if (queryParams['codigo'] && queryParams['print'] === 'true') {
      this.imprimirTicket(Number(queryParams['codigo']));
    }
  }

  ngAfterViewInit(): void {
    this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
      this.getLaudoHigienizacao();
    });
  }

  navegarNovoLaudo() {
    this.router.navigate(['cadastro/laudo-higienizacao']);
  }

  mudarPagina(pagina: number) {
    this.pesquisaParams.Pagina = pagina;
    this.numeroPagina = pagina;
    this.getLaudoHigienizacao(pagina + 1);
  }

  formatarCampos(campo: string | number | Date): string {
    return campo === null || campo === '' ? 'Não Informado' : String(campo);
  }

  createPayload() {
    const payload: any = {
      ...this.form.value
    };
    Object.keys(payload).forEach(
      key =>
        (payload[key] === null ||
          payload[key] === '' ||
          payload[key] === undefined) &&
        delete payload[key]
    );
    return payload;
  }

  getLaudoHigienizacao(pageNumber?: number) {
    this.isLoading = true;
    const payload = this.createPayload();

    this.laudoHigienizacaoService
      .GetLaudoHigienizacaoPaginated({
        DT_GATE_ENTR_INIC: payload.DT_GATE_ENTR_INIC,
        DT_GATE_ENTR_FIM: payload.DT_GATE_ENTR_FIM,
        TX_PLCA_CAVA: (payload.TX_PLCA_CRRT ?? '').replace('-', ''),
        FK_EPSA: Number(payload.FK_EPSA),
        pageNumber: pageNumber,
        pageSize: 20
      })
      .subscribe({
        next: (response: IGetLaudoHigienizacaoPaginated) => {
          this.isLoading = false;
          this.tableData = response.ITEMS.map(item => {
            this.pkFunc = item.PK_LAUD_SRVC;
            return {
              codigo: item.PK_LAUD_SRVC ?? '---',
              agendamento:
                item.PK_GATE_ENTR && item.DT_AGND
                  ? `Entrada ${item.PK_GATE_ENTR} · ${formatarData(item.DT_AGND)}`
                  : formatarData(item.DT_AGND) ?? '---',
              dataServico: item.DT_SRVC_ENTR ? formatarData(item.DT_SRVC_ENTR) : '---',
              empresa: item.NM_TRND ?? item.NM_EPSA ?? '---',
              placaCavalo: formatarPlaca(item.TX_PLCA_CAVA) ?? '---',
              motorista: item.NM_MTRT ?? '---',
              dataCriacao: item.DT_CRIA,
              dataFinalizacao: item.DT_TERM,
              situacao: item.DT_GATE_SAID == null ? false : true,
              isPago: item.FK_SRVC_ENTR_PGMT_SAID != null
            };
          });
          this.maxPages = response.TOTAL_PAGES;
        },
        error: (_error: any) => {
          this.isLoading = false;
        }
      });
  }

  fecharModalLaudo(): void {
    this.showModal = false;
    this.pdfBase64 = '';
  }

  private mensagemErroLaudo(error: any): string {
    return (
      error?.error?.Title ||
      error?.error?.title ||
      error?.message ||
      'Não foi possível carregar o laudo. Verifique se o serviço já foi lançado no caixa.'
    );
  }

  abrirLaudoHigienizacao(idLaudo: number) {
    this.isLoading = true;
    this.pdfBase64 = '';
    this.showModal = false;

    this.laudoHigienizacaoService
      .GetReceiptLaudoHigienizacaoById(idLaudo)
      .subscribe({
        next: (res: IGetReportBase64) => {
          if (!res?.ReportBase64) {
            this.isLoading = false;
            this.swalAlert.showAlert(
              'Atenção!',
              'O laudo foi gerado sem conteúdo. Tente novamente.',
              'warning'
            );
            return;
          }

          this.pdfBase64 = 'data:application/pdf;base64,' + res.ReportBase64;
          this.showModal = true;
          this.isLoading = false;
        },
        error: error => {
          this.isLoading = false;
          this.showModal = false;
          this.swalAlert.showAlert(
            'Atenção!',
            this.mensagemErroLaudo(error),
            'warning'
          );
        }
      });
  }

  exportPdf(id: number) {
    this.isLoading = true;

    this.laudoHigienizacaoService
      .GetReceiptLaudoHigienizacaoById(id)
      .subscribe({
        next: (response: IGetReportBase64) => {
          this.appExportBase64.downloadPDF(
            response.ReportBase64,
            'laudo-higienizacao'
          );
          this.isLoading = false;
        },
        error: error => {
          this.isLoading = false;
          this.swalAlert.showAlert(
            'Atenção!',
            this.mensagemErroLaudo(error),
            'warning'
          );
        }
      });
  }

  imprimirTicket(id: number) {
    this.isLoading = true;

    this.laudoHigienizacaoService.GetReceiptLaudoHigienizacaoById(id).subscribe({
      next: (response: IGetReportBase64) => {
        this.isLoading = false;
        this.impressoraService.impressoraTicket(
          response.ReportBase64,
          'application/pdf'
        );
      },
      error: error => {
        this.isLoading = false;
        this.swalAlert.showAlert(
          'Atenção!',
          this.mensagemErroLaudo(error),
          'warning'
        );
      }
    });
  }
}

